var map = {
	"./basic/content/activity-report.json": 113,
	"./basic/content/basic_pages.json": 598,
	"./basic/content/blog.json": 261,
	"./basic/content/news.json": 482,
	"./basic/content/sponsors.json": 218,
	"./posts/content/impect-becomes-pysports-first-sponsor.json": 786,
	"./posts/content/new-kloppy-documentation.json": 247,
	"./posts/content/𝐏𝐲𝐒𝐩𝐨𝐫𝐭-𝐗-𝐏𝐲𝐃𝐚𝐭𝐚-𝐄𝐢𝐧𝐝𝐡𝐨𝐯𝐞𝐧-𝟐𝟎𝟐𝟓.json": 785
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 784;